export default __webpack_public_path__ + "static/media/phlogo.edef844d.JPG";